<template>
  <div class="flex flex-col items-center space-y-16 object-contain" id="strategies">
    <div class="flex max-w-[900px] flex-col items-center space-y-6 px-6">
      <h2 class="text-ontick-green-600 font-semibold uppercase leading-6 tracking-wide">
        {{ header.title }}
      </h2>
      <h1 class="text-3xl font-extrabold sm:text-center lg:text-4xl">
        {{ header.heading }}
      </h1>
      <div v-if="Array.isArray(header.subtitle)" class="space-y-4">
        <p class="text-gray-500 dark:text-gray-400" v-for="(paragraph, index) in header.subtitle" :key="index">
          {{ paragraph }}
        </p>
      </div>
      <p class="text-lg text-gray-500 dark:text-gray-400 sm:text-center" v-else>
        {{ header.subtitle }}
      </p>
    </div>

    <div
      class="mx-auto hidden w-min max-w-full items-center space-x-4 overflow-x-auto overflow-y-visible px-6 py-4 md:flex"
      v-if="data.length < 4"
    >
      <card-marketplace
        v-for="(item, index) in data"
        :key="`${item.product_id}${index}`"
        class="border-ontick-steel-300 w-[265px] border-2 dark:border-none"
        :product="item"
        :strategy="item.strategies[0]"
        @click.native="Details(item.strategies[0].strategy_id, item.product_id, index)"
        disableAdd
      />
    </div>
    <swiper class="w-full py-6 px-3 md:px-12" :options="options" :class="{ 'md:hidden': data.length < 4 }">
      <swiper-slide v-for="(item, index) in data" :key="index">
        <card-marketplace
          class="border-ontick-steel-300 border-2 dark:border-none"
          :product="item"
          :strategy="item.strategies[0]"
          @click.native="Details(item.strategies[0].strategy_id, item.product_id, index)"
          disableAdd
        />
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
    CardMarketplace: () => import("@/app/modules/marketplace/components/products/card/marketplace-card.component.vue"),
  },
  props: {
    data: {
      type: Array,
    },
    header: {
      type: Object,
    },
  },

  data() {
    return {
      options: {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 16,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1440: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
        },
      },
    };
  },

  methods: {
    Details(strategy, product, index) {
      let params = {
        strategy: strategy,
        product: product.product_id,
        index: index,
      };
      this.$emit("details", params);
    },
  },
};
</script>

<style></style>
